import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Bulken en cutten</title>
                <link rel="canonical" href={route("blogs.thirteenth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Als je spiermassa wilt creëren, omdat je dat mooi vind of omdat je gewicht wilt verhogen zonder vet aan te komen, kun je het beste gebruik maken van bulken en cutten. In deze methode wissel je periodes van meer eten af met minder eten."
                />
                <meta
                    property="og:description"
                    content="Als je spiermassa wilt creëren, omdat je dat mooi vind of omdat je gewicht wilt verhogen zonder vet aan te komen, kun je het beste gebruik maken van bulken en cutten. In deze methode wissel je periodes van meer eten af met minder eten."
                />
                <meta property="og:url" content={route("blogs.thirteenth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Bulken en cutten - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/bulken-en-cutten.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/bulken-en-cutten.webp"
                                    type="image/webp"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/bulken-en-cutten.jpg"
                                    type="image/jpeg"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/bulken-en-cutten.jpg"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Bulken en cutten
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Als je spiermassa wilt creëren, omdat je dat mooi vind
                        of omdat je gewicht wilt verhogen zonder vet aan te
                        komen, kun je het beste gebruik maken van bulken en
                        cutten. In deze methode wissel je periodes van meer eten
                        af met minder eten.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is bulken?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Bulken is afgeleid van het Engelse woord ‘bulk’. De
                        vertaling hiervan is massaal. Dat is ook gelijk het doel
                        van het bulken: Het aankomen van spiermassa.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Om spiermassa aan te komen is het belang dat je een
                        calorieoverschot hanteert. Dat wil zeggen dat je meer
                        moet eten dan je onderhoud. Er zijn meerdere manieren om
                        dat te doen. Zo is er de clean bulk en de dirty bulk.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Bij een clean bulk hou je het calorieoverschot beperkt.
                        Dit wil zeggen dat je 200 á 500 kcal boven je onderhoud
                        gaat zitten. Hiermee zou je dan 0,2 á 0,5 kilo per week
                        moeten aankomen. Kom je meer aan? Dan zul je je
                        calorieëninname moeten verlagen zodat je maar 0,2 á 0,5
                        kilo aankomt. Kom je minder of niet aan? Dan moet je je
                        calorieëninname juist verhogen zodat je genoeg aankomt.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Bij een dirty bulk hou je niet of nauwelijks rekening
                        met de hoeveelheid calorieën die je binnenkrijgt.
                        Hierbij eet je zoveel mogelijk, zodat je aankomt.
                        Hierbij hoef je ook niet te kijken of producten gezond
                        zijn of niet, als kun je dat natuurlijk ook doen mocht
                        je je daar prettig bij voelen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Het voordeel van de dirty bulk is dat je kunt doen wat
                        je wil qua voeding, zolang je maar voldoende eiwitten
                        binnenkrijgt. Een zak chips, pizza, friet en dergelijke
                        zijn allemaal toegestaan. Daarnaast hoef je hiermee
                        nauwelijks je eten te continue te tracken. Het grote
                        nadeel van de dirty bulk is dat jij boven de spiermassa
                        die je gaat creëren ook een dikkere laag vet gaat
                        krijgen omdat je calorieoverschot heel erg hoog zal
                        liggen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Bij de clean bulk is het voordeel dat je je spieren die
                        je aankomt ook blijft zien. Hierdoor zie je in de
                        spiegel je vooruitgang veel beter dan bij een dirty
                        bulk. Hierbij is het wel van belang dat je je eten goed
                        trackt, zodat je zeker weet dat je niet te weinig of
                        juist te veel eet.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is cutten?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Cutten is dan weer afgeleid van het Engelse woord ‘cut’.
                        De letterlijke vertaling van cut is snee. Eigenlijk houd
                        cutten in dat je je vet gaat wegsnijden, door middel van
                        training. Bij het cutten wil je vet verliezen, terwijl
                        de spiermassa behouden blijft.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Bij cutten ga je een calorietekort hanteren. Hierbij
                        houd je een tekort aan van 200 á 500 calorieën minder
                        dan je onderhoud. Je wilt geen groter calorietekort
                        hanteren omdat dat ten koste kan gaan van je spiermassa.
                        Het is namelijk belangrijk om tijdens het cutten de
                        opgebouwde spiermassa bij het bulk gaat behouden.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Voor het afvallen geldt hetzelfde als bij het aankomen
                        bij een clean bulk. Je wilt zo’n 0,5 kilo per week
                        afvallen. Als je teveel afvalt gaat dit ten koste van je
                        spiermassa. Val je te weinig af, dan zul je meer tijd
                        kwijt zijn aan het cutten. Val je minder dan 0,5 kilo af
                        per week, verlaag je calorie inname een beetje zodat je
                        weer ongeveer 0,5 kilo afvalt.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Bij het cutten kun je ook meer cardio toevoegen. Dit kan
                        via duursport zoals wandelen of fietsen, of via
                        HIIT-training. Dit staat voor High Intense Interval
                        Training. Hiermee verhoog je je caloriebehoefte,
                        waardoor je niet minder hoeft te gaan eten.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wanneer moet je bulken en wanneer moet je cutten?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Dit is voor iedereen anders. Wil je bijvoorbeeld volgend
                        jaar in de zomer helemaal afgetraind zijn, dan dien je
                        het bulken en cutten erop aan te passen dat je dan zo
                        gespierd en droog mogelijk bent.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Uiteindelijk zul je zelf aanvoelen of je wilt gaan
                        bulken of cutten. Vind je jezelf net iets te dik worden
                        tijdens het bulken kun je besluiten om weer even te gaan
                        cutten. Ben je wel klaar met dat weinig eten tijdens het
                        cutten kun je weer besluiten om te gaan bulken. Zo
                        wisselen bulken en cutten elkaar steeds af, waardoor je
                        uiteindelijk spiermassa hebt gewonnen met een laag
                        vetpercentage.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
